import React, { useContext } from 'react'
import { UserContext } from '../App'
import { Alert } from '@mui/material'

const PermissionCheck = ({ roles, children, showAlert }) => {
    const { user } = useContext(UserContext)

    if (!user) {
        return null // or a spinner
    }

    const allowedRoles = [...roles]
    const userRoles = user.employee?.teams || []
    // Site admins bypass all team checks on the server
    const isAllowed =
        user?.security?.isSiteAdmin ||
        userRoles.some(x => allowedRoles.includes(x))

    if (isAllowed) {
        return <>{children}</>
    } else {
        return showAlert ? (
            <Alert severity="error">You are not authorised to view this page.</Alert>
        ) : null
    }
}

export default PermissionCheck